<template>
  <a :href="whatsappUrl" target="_blank" class="whatsapp-float">
    <i class="whatsapp-icon"></i>
  </a>
</template>

<script>
export default {
  name: 'WhatsAppButton',
  props: {
    formData: {
      type: Object,
      default: () => ({})
    },
    currentStep: {
      type: Number,
      default: 0
    }
  },
  computed: {
    whatsappUrl() {
      const phone = '56920633976';
      const message = this.generateMessage();
      const encodedMessage = encodeURIComponent(message);
      return `https://api.whatsapp.com/send/?phone=${phone}&text=${encodedMessage}&type=phone_number&app_absent=0`;
    }
  },
  methods: {
    generateMessage() {
      const stepNames = [
        'selección de producto',
        'datos del perro',
        'peso',
        'raza',
        'cumpleaños',
        'alergias',
        'selección de plan',
        'extras',
        'email',
        'checkout'
      ];
      
      let message = `Hola! Vengo del formulario web go.tupibox.com\n\n`;
      message += `📍 Estoy en: ${stepNames[this.currentStep] || 'inicio'}\n\n`;
      
      // Datos básicos del perro
      if (this.formData.petname) {
        message += `🐕 Perro: ${this.formData.petname}\n`;
      }
      if (this.formData.sex) {
        message += `   Sexo: ${this.formData.sex === 'He' ? 'Macho' : 'Hembra'}\n`;
      }
      if (this.formData.weight) {
        message += `   Peso: ${this.formData.weight} kg\n`;
      }
      if (this.formData.breed) {
        message += `   Raza: ${this.formData.breed}\n`;
      }
      
      // Tipo de producto
      if (this.formData.product_type) {
        const productName = this.formData.product_type === 'fresh' 
          ? 'TupiBox Fresh (Comida Natural)' 
          : 'TupiBox Original (Juguetes y Snacks)';
        message += `\n📦 Producto: ${productName}\n`;
      }
      
      // Plan seleccionado
      if (this.formData.plan) {
        const planText = this.formData.plan.includes('x3') ? '3 meses' 
                       : this.formData.plan.includes('x6') ? '6 meses'
                       : '1 mes';
        const payMethodText = this.formData.payMethod === 'subscription' ? 'Suscripción' : 'Pago único';
        message += `   Plan: ${planText} (${payMethodText})\n`;
      }
      
      // Datos Fresh específicos
      if (this.formData.product_type === 'fresh') {
        if (this.formData.activityLevel) {
          message += `   Actividad: ${this.formData.activityLevel}\n`;
        }
        if (this.formData.portions) {
          message += `   Porciones/mes: ${this.formData.portions}\n`;
        }
      }
      
      // Alergias
      if (this.formData.allergie && this.formData.allergie !== 'Nada') {
        message += `\n⚠️ Alergia: ${this.formData.allergie}\n`;
      }
      
      // Email de contacto
      if (this.formData.email) {
        message += `\n📧 Email: ${this.formData.email}\n`;
      }
      
      message += `\nNecesito ayuda con mi pedido.`;
      
      return message;
    }
  }
}
</script>

<style scoped>
.whatsapp-float {
  position: fixed;
  width: 60px;
  height: 60px;
  bottom: 40px;
  right: 40px;
  background-color: #25d366;
  color: #fff;
  border-radius: 50px;
  text-align: center;
  font-size: 30px;
  box-shadow: 2px 2px 3px #999;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
}

.whatsapp-float:hover {
  background-color: #128c7e;
}

.whatsapp-icon:before {
  content: "\f232";
  font-family: "Font Awesome 5 Brands";
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
}
</style>
